import Video from "../../../../content/posts/be-aware-of-css-animation-dark-side/cant-change-style.mp4";
import { BlankLink } from "../../../../src/components/mdx/link";
import * as React from 'react';
export default {
  Video,
  BlankLink,
  React
};